// extracted by mini-css-extract-plugin
export default {"form":"hauler-edit-form_form__FcUs9","actionButtons":"hauler-edit-form_actionButtons__7Ph7x","saveBtn":"hauler-edit-form_saveBtn__Yil51"};